<!--<app-export-xls [sourceId]="id" type="2" class="m&#45;&#45;margin-top-15"></app-export-xls>-->

<section class="content" *ngIf="(postState | async).postDetail !== null">
  <app-breadcrumbs type="postReport"></app-breadcrumbs>

  <div class="row">
    <div class="col-md-5">
      <h6 class="content-header">Audited post</h6>
      <div class="card">
        <div class="row card-body post-report">
          <div class="col-md-6">
            <p class="post-text">{{(postState | async).postDetail.caption}}</p>
            <p class="date">{{((postState | async).postDetail.date * 1000) | date}}</p>
          </div>
          <div class="col-md-6 text-center">
            <a href="{{'https://www.instagram.com/' + (postState | async).postDetail.profile.username}}" target="_blank">
              <img class="post-image rounded-sm" [src]="(postState | async).postDetail.thumbnail_src">
            </a>
            <div class="info">
              <span>
                <img class="post-icon" src="assets/images/icons/heart.png"/>
                <span class="post-value">{{(postState | async).postDetail.like_count | shortcutNumbers}}</span>
              </span>
              <span>
                <img class="post-icon" src="assets/images/icons/comment.png"/>
                <span class="post-value">{{(postState | async).postDetail.comment_count | shortcutNumbers}}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-7">
      <h6 class="content-header">Profile</h6>
      <div class="card">
        <div class="row card-body profile-info">
          <div class="col-md-4 text-center">
            <a  class="avatar-content" href="{{'https://www.instagram.com/' + (postState | async).postDetail.profile.username}}" target="_blank">
              <img [src]="(postState | async).postDetail.profile.profile_pic_url" alt="Audited profile avatar" class="avatar"/>
              <img class="icon-platform" src="assets/images/icons/instagram-2.png"/>
            </a>
          </div>
          <div class="col-md-8 profile-details">
            <h1 class="profile-name">
              <a href="{{'https://www.instagram.com/' + (postState | async).postDetail.profile.username}}" target="_blank">
                &#64;{{(postState | async).postDetail.profile.username}}
              </a>
            </h1>
            <p class="profile-description">{{(postState | async).postDetail.profile.full_name}}</p>
            <p class="profile-description">Generated on {{(profileState | async).audit.added_time * 1000 | date}}</p>
            <div class="report-results">
              <div class="b-left">
                <h2>{{(postState | async).postDetail.profile.media_count | shortcutNumbers}}</h2>
                <p class="sub-text">Posts</p>
              </div>
              <div class="b-left">
                <h2>{{(postState | async).postDetail.profile.followed_by | shortcutNumbers}}</h2>
                <p class="sub-text">Followers</p>
              </div>
              <div class="b-left">
                <h2>{{(postState | async).postDetail.profile.follows | shortcutNumbers}}</h2>
                <p class="sub-text">Followed</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="content" *ngIf="(profileState | async).audit !== null && (profileState | async).audit.status === 1">
  <div class="card">
    <div class="card-body-placeholder">
      <h3>The report is under preparation. Data are being collected.</h3>
      <p>This can take up to 5 hours. We are analyzing all data in real time.</p>
      <div class="report-loader my-5" *ngIf="(profileState | async).profileProgress.like.percent !== 0">
        <div class="progress"
             [ngStyle]="{width: ((profileState | async).profileProgress.like !== undefined ? (profileState | async).profileProgress.like.percent : 0) + '%'}">
        </div>
      </div>
      <div
        *ngIf="(profileState | async).profileProgress.like.percent !== 0"
        class="value-bubble"
        [ngStyle]="{left: 'calc(' + ((profileState | async).profileProgress.like !== undefined ? (profileState | async).profileProgress.like.percent : 0) + '% - 95px)'}">
        <h2 class="text-cyan">{{(profileState | async).profileProgress.like !== undefined ? (profileState | async).profileProgress.like.percent : 0}}%</h2>
        <span>done</span>
      </div>

      <div class="m-5 loading-bg loading-total-bg"><div class="loading-bar loading-total-bar"  [ngStyle]="{width: (profileState | async).profileProgress.like.percent + '%'}"></div></div>
<!--      <h5 class="font-weight-normal">Current progress is: <span class="m&#45;&#45;font-accent">{{(profileState | async).profileProgress.like.percent}}%</span></h5>-->
    </div>
  </div>
</section>

<!--  <app-followers-reliability type="2" class="w-100"></app-followers-reliability>-->
<section class="content">
  <app-interaction-analyze type="2" class="w-100" auditType="profile"></app-interaction-analyze>
  <app-followers-demography type="2" class="w-100" auditType="profile"></app-followers-demography>
  <app-followers-location type="2" class="w-100" auditType="profile"></app-followers-location>
  <app-profile-media type="2"></app-profile-media>
</section>


<div class="demo-bar" *ngIf="!((profileState | async).audit !== null && (profileState | async).audit.status)">
  <a class="btn btn-lg btn-blue btn-blue-hover" routerLink="/payment/add">Buy credit and view PRO analitics </a>
</div>

